import React, { useState, useEffect } from "react";
import {
	Box,
	Button,
	Typography,
	List,
	ListItem,
	ListItemText,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	InputLabel,
	MenuItem,
	Select,
	FormControl,
	Drawer,
	useMediaQuery,
	Alert,
	Tabs,
	Tab,
	Link,
	Snackbar,
	CircularProgress,
} from "@mui/material";

import "./Rspl.css";
import PageTitle from "../../components/PageTitle/PageTitle";
import customHttp from "../../services/customHTTP";
import Divider from "@mui/material/Divider";
import ContextFilterAndSort from "../../components/ContextFilterAndSort/ContextFilterAndSort";
import MenuIcon from "@mui/icons-material/Menu";
import Datagrid from "../../components/Datagrid/Datagrid";
import { useCart } from "../../context/cartContext";
import { useSite } from "../../context/siteContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { ASSETS_BASE_URL, RSPL_LIST } from "../../config";
import { ShoppingBasketOutlined, ShoppingCart, ShoppingCartOutlined } from "@mui/icons-material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

const initialItems = [];

function Rspl() {
	const [items, setItems] = useState(initialItems);
	const [selectedItem, setSelectedItem] = useState([]);
	const [listSearchTerm, setListSearchTerm] = useState("");
	const [products, setProducts] = useState([]);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [sortOption, setSortOption] = useState("");
	const [tabValue, setTabValue] = useState("All");
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [alertisSuccess, setAlertIsSuccess] = useState(false);
	const [openAlert, setOpenAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState("");
	const [selectedProductRows, setSelectedProductRows] = useState([]);
	const isMobile = useMediaQuery("(max-width:600px)");
	const { selectedSite, siteData, selectedSiteCurrency, currencySymbol } = useSite();
	const { addMultipleToCart } = useCart();
	const { user } = useAuth();
	const [dialogOpen, setDialogOpen] = useState(false);
	const [listItems, setListItems] = useState([]);
	const [selectedList, setSelectedList] = useState("");
	const [isCreatingNewList, setIsCreatingNewList] = useState(false);
	const [newListName, setNewListName] = useState("");
	const [newListDescription, setNewListDescription] = useState("");
	const [firstLoad, setFirstLoad] = useState(true);
	const [spareParts, setSpareParts] = useState({});
	const navigate = useNavigate();
	const [rsplSelected, setRsplSelected] = useState([]);
	const [partsData, setPartsData] = useState([]);

	const sortOptions = ["Name Asc", "Name Desc"];
	const columns = [
		{
			field: "product_name",
			headerName: "Part Name",
			flex: 1,
			renderCell: (params) => {
				const defaultImage = `${ASSETS_BASE_URL}/stock.png`;

				const handleError = (e) => {
					e.target.onerror = null; // Prevent infinite loop
					e.target.src = defaultImage; // Fallback to default image
				};

				const src = `${ASSETS_BASE_URL}/ProductImages/TMB/${params.row?.product_number}.png`;

				return (
					<div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-start" }}>
						<img
							src={src}
							alt={params.row?.product_name}
							onError={handleError}
							style={{
								width: "40px",
								height: "40px",
								objectFit: "cover",
								borderRadius: "4px",
							}}
						/>
						<div>
							<Link
								sx={{ cursor: "pointer" }}
								variant="body2"
								onClick={() => {
									navigate(`/machines/${params.row.machine_id}/${params.row?.product_id}`);
								}}>
								{params.row?.product_name}
							</Link>
						</div>
					</div>
				);
			},
		},
		{
			field: "product_number",
			headerName: "Part #",
			width: 200,
		},
		{
			field: "product_sell_price",
			headerName: "Price",
			width: 200,
			renderCell: (params) => {
				const key = `price_${selectedSiteCurrency}`;
				let currencyPrice = params.row[key];
				if (currencyPrice === "0") {
					currencyPrice = params.row.product_sell_price;
				}
				// If the product is purchasable, use the currency price; otherwise, set it to 0
				const finalPrice = params.row.purchasable ? currencyPrice : 0;
				if (params.row.purchasable === 1) {
					return (
						<div>
							{currencySymbol}
							{finalPrice}
						</div>
					);
				} else {
					return null;
				}
			},
		},
	];

	useEffect(() => {
		const fetchMachines = async () => {
			try {
				console.log("RSPL LIST: ", RSPL_LIST);
				const reqBody = {
					site_number: selectedSite,
				};

				const response = await customHttp.post("/machines/bysiteid", reqBody);
				if (response?.data?.success) {
					const uniqueMachines = response.data.data.filter(
						(machine, index, self) =>
							index === self.findIndex((m) => m.machine_name === machine.machine_name)
					);

					setItems(uniqueMachines);
					setSelectedItem(uniqueMachines[0]);
				} else {
					setError("Failed to fetch data: No success flag.");
				}
			} catch (err) {
				setError("Failed to fetch data: " + err.message);
			} finally {
				setLoading(false);
			}
		};

		const fetchRecommendationsLists = async () => {
			try {
				const user_id = user.user_id;
				const site_id = siteData.filter((i) => i.customer_site_number === selectedSite)[0]?.site_id;

				if (!site_id) {
					console.error("Site ID not found");
					return;
				}

				// Fetch recommendations
				const recommendationsResponse = await customHttp.get(`/recommendations/${user_id}/${site_id}`);
				if (recommendationsResponse.status === 200) {
					let recommendations = [];

					recommendations = recommendationsResponse.data.data.filter((item) => item.user_id === user.user_id);

					setListItems(recommendations);

					if (recommendations.length > 0) {
						const firstRecommendation = recommendations[0];
						setSelectedList(firstRecommendation);
					}
				} else {
					console.error("Failed to fetch recommendations:", recommendationsResponse.error);
				}
			} catch (error) {
				console.error("Error fetching recommendations or products:", error);
			}
		};

		if (selectedSite !== "") {
			fetchMachines();
			fetchRecommendationsLists();
		}
	}, [selectedSite, siteData]);

	const handleSortChange = (value) => {
		setSortOption(value);

		if (value === "Name Asc") {
			setItems((prevProducts) => [...prevProducts].sort((a, b) => a.machine_name.localeCompare(b.machine_name)));
		} else if (value === "Name Desc") {
			setItems((prevProducts) => [...prevProducts].sort((a, b) => b.machine_name.localeCompare(a.machine_name)));
		}
	};

	const getProductNumbers = (products, prods) => {
		return products
			.map((product) => {
				const prod = prods.find((p) => p.product_id === product.product_id);
				return prod ? prod.product_number : null;
			})
			.filter((productNumber) => productNumber !== null) // Remove null values if no match is found
			.join(",");
	};

	const handleSaveList = async () => {
		try {
			let response1 = undefined; // declared like this for new list response setSelectedList does not update in time
			if (selectedList || (newListName && newListDescription)) {
				if (isCreatingNewList) {
					const user_id = user.user_id;
					const site_id = siteData.filter((i) => i.customer_site_number === selectedSite)[0]?.site_id;
					if (!site_id) {
						Swal.fire({
							icon: "error",
							title: "Error",
							text: "Failed to Create the list. Please try again",
						});
						return;
					}
					const newList = {
						name: newListName,
						description: newListDescription || "",
						user_id,
						site_id,
					};
					const listExists = items.some((item) => item.name === newListName);
					if (listExists) {
						setError("A list with this name already exists for this site.");
						return;
					}
					response1 = await customHttp.post("/recommendations", newList);
					if (response1.status === 200) {
						setListItems((prev) => [
							...prev,
							{
								id: prev.length + 1,
								label: newListName,
								description: newListDescription,
							},
						]);
						setSelectedList(response1.data.data);
					} else {
						Swal.fire({
							icon: "error",
							title: "Error creating list",
							confirmButtonText: "Okay",
						});
						setDialogOpen(false);
						return;
					}
				}
			}
			const prods = tabValue === "All" ? Object.values(spareParts).flat() : spareParts[tabValue];
			const filteredProducts = prods
				.filter((product) => selectedProductRows.includes(product.product_id))
				.map((product) => ({
					product_id: product.product_id,
					machine_id: product.machine_id,
				}));
			const response = await customHttp.post("/recommendations/products", {
				list_id: !response1 ? selectedList.id : response1.data.data.id, // if its a new list
				products: filteredProducts,
			});
			if (response.status === 200) {
				setDialogOpen(false);
				const alreadyExisting = response.data.results.filter((res) => res.status === "exists");
				const newProducts = response.data.results.filter((res) => res.status !== "exists");

				const alreadyExistingNumbers = getProductNumbers(alreadyExisting, prods);
				const newProductNumbers = getProductNumbers(newProducts, prods);
				let html = "";
				let type = "success";
				let title = "Success";
				if (newProducts.length > 0 && alreadyExisting.length <= 0) {
					html = `Part(s) Added to the List`;
				} else if (newProducts.length <= 0 && alreadyExisting.length > 0) {
					type = "info";
					title = "Info";
					html = `<p style="font-size: 11px;"><b>Note:</b> Followings parts already exists in selected List, <b>${alreadyExistingNumbers}</b></p>
				`;
				} else if (newProducts.length > 0 && alreadyExisting.length > 0) {
					html = `Part(s) Added to the List<br/><p style="font-size: 11px; margin-top: 10px"><b>Note:</b> Followings parts already exists in selected List, <b>${alreadyExistingNumbers}</b></p>
				`;
				}

				Swal.fire({
					icon: type,
					title: title,
					html: html,
				});
			} else if (!response.data.success) {
				Swal.fire({
					icon: "error",
					title: "Error Adding to List",
					confirmButtonText: "Okay",
				});
			}
		} catch (error) {
			console.error("Error fetching product name:", error);
		}
	};

	const handleItemClick = async (item) => {
		setFirstLoad(true);
		setSelectedItem(item);
	};

	const filteredItems = items.filter((item) =>
		item?.machine_name?.toLowerCase().includes(listSearchTerm.toLowerCase())
	);

	useEffect(() => {
		const fetchRSPLParts = async (item) => {
			try {
				const reqBody = {
					machine_id: item.machine_id,
				};
				const sparePartsDict = {};
				const response = await customHttp.post("/products/bymachineid", reqBody);
				if (response.status === 200) {
					RSPL_LIST.forEach((type) => {
						sparePartsDict[type.value] = response.data.data.filter((product) =>
							type.key.includes(product.product_rspl_code)
						);
					});
					const rsplMapping = Object.fromEntries(
						RSPL_LIST.flatMap(({ key, value }) => key.map((k) => [k, value]))
					);
					console.log("RSPL Mapping", rsplMapping);
					setSpareParts(sparePartsDict);
					setFirstLoad(false);
					setTabValue("All");
					setPartsData(Object.values(sparePartsDict).flat());
				}
			} catch (error) {
				console.error("Error fetching products:", error);
			}
		};
		if (selectedItem && Object.keys(selectedItem).length > 0 && firstLoad) {
			fetchRSPLParts(selectedItem);
			console.log("Selected Item: ", selectedItem);
		}
		console.log("Products in UE: ", spareParts);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedItem, firstLoad]);

	useEffect(() => {
		if (items.length > 0) {
			console.log("Filtered Items: ", items);
			setSelectedItem(items[0]);
		}
	}, [items]);

	const handleListSearchChange = (value) => {
		setListSearchTerm(value);
	};

	const handleAddToCart = async (id) => {
		console.log("Seelcted Site: ", selectedSite);
		const purchasableProducts = [];
		const nonPurchasableProducts = [];
		var message = "Products added to";
		selectedProductRows.forEach((productId) => {
			const prods = tabValue === "All" ? Object.values(spareParts).flat() : spareParts[tabValue];
			const product = prods.find((product) => product.product_id === productId);
			if (product) {
				if (product.purchasable === 1) {
					const productEntry = {
						ProductID: product.product_id,
						Quantity: 1,
						Site: selectedSite,
					};
					purchasableProducts.push(productEntry);
				} else {
					const productEntry = {
						machine_id: product.machine_id,
						product_id: product.product_id,
						site_number: selectedSite,
						user_id: user.user_id,
					};
					nonPurchasableProducts.push(productEntry);
				}
			}
		});
		console.log("Selected Rows RSPL: ", selectedProductRows);
		console.log("Purchaseable Products: ", purchasableProducts);
		if (purchasableProducts.length > 0) {
			await addMultipleToCart(purchasableProducts);
			message += " Cart successfully!";
			setOpenAlert(true);
			setAlertIsSuccess(true);
			setAlertMessage(message);

			setTimeout(() => {
				setOpenAlert(false);
			}, 3000);
		}
		if (nonPurchasableProducts.length > 0) {
			Swal.fire({
				icon: "info",
				text: "Some of the Selected Part(s) Cannot be Purchased. Do you want to add them to Requests?",
				confirmButtonText: "Yes",
				showDenyButton: true,
				denyButtonText: "No",
			}).then(async (results) => {
				if (results.isConfirmed) {
					await handleAddToRequest(nonPurchasableProducts);
				}
			});
		}
	};

	// const handleRowSelect = (selectedRows, visibleRowIds) => {
	// 	setSelectedProductRows(selectedRows);
	// 	console.log("Selected Rows: ", selectedRows);

	// 	setRsplSelected((prev) => {
	// 		const prevSet = new Set(prev);
	// 		const selectedSet = new Set(selectedRows);
	// 		const visibleSet = new Set(visibleRowIds);

	// 		const updated = new Set(prevSet);

	// 		// ✅ Add new selections
	// 		selectedRows.forEach((id) => updated.add(id));

	// 		// ✅ Remove only rows that:
	// 		// - were previously selected
	// 		// - are currently visible
	// 		// - AND are now unselected
	// 		prev.forEach((id) => {
	// 			if (visibleSet.has(id) && !selectedSet.has(id)) {
	// 				updated.delete(id);
	// 			}
	// 		});

	// 		return Array.from(updated);
	// 	});
	// };

	// useEffect(() => {
	// 	console.log("Selected Rows RSPL: ", rsplSelected);
	// }, [rsplSelected]);

	const handleRowSelect = (rows) => {
		setSelectedProductRows(rows);
	};

	const handleAddToRequest = async (arg) => {
		try {
			const reqBody = {
				products: arg,
			};

			const response = await customHttp.post("/request_list/saverequestlist-bulk", reqBody);
			if (response.status === 200) {
				let message = "Part(s) Added to Request List";
				setOpenAlert(true);
				setAlertIsSuccess(true);
				setAlertMessage(message);

				setTimeout(() => {
					setOpenAlert(false);
				}, 3000);
			}
		} catch (error) {
			console.error("Error Adding products to Request list:", error);
		}
	};

	const toggleDrawer = () => {
		setDrawerOpen(!drawerOpen);
	};

	const handleTabChange = (event, newValue) => {
		console.log("New Selected Tab: ", newValue);
		setTabValue(newValue);
		newValue === "All" ? setPartsData(Object.values(spareParts).flat()) : setPartsData(spareParts[newValue]);
	};

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	if (error && !loading) {
		return (
			<Alert severity="error" className="error-alert">
				{error}
			</Alert>
		);
	}
	return (
		<>
			<Box className="recommendation-page" sx={{ padding: isMobile ? "10px" : "40px" }}>
				<PageTitle title="Recommended Spare Parts Lists (RSPL)" />

				<Box display="flex" justifyContent={isMobile ? "space-between" : "flex-end"} mb={2}>
					{isMobile && (
						<IconButton onClick={toggleDrawer}>
							<MenuIcon />
						</IconButton>
					)}
				</Box>

				<Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
					<Box width="250px" p={2}>
						<ContextFilterAndSort
							value={listSearchTerm}
							onSearchChange={handleListSearchChange}
							placeholder="Search list"
							options={sortOptions}
							selectedOption={sortOption}
							onSortChange={handleSortChange}
							showSort
							showSearch
						/>
						<List
							style={{
								overflowY: "auto",
								height: "calc(100% - 48px)",
								maxHeight: "500px",
							}}>
							{filteredItems.length > 0 ? (
								filteredItems.map((item) => (
									<ListItem
										key={item.id}
										button
										onClick={() => handleItemClick(item)}
										style={{
											cursor: "pointer",
											backgroundColor: selectedItem?.id === item.id ? "#e8e8e8" : "transparent",
											height: "45px",
										}}
										sx={{
											"&:hover": {
												color: "var(--primary-main)",
												transition: "0.2s",
											},
										}}>
										<ListItemText
											primary={item.machine_name}
											primaryTypographyProps={{
												style: {
													color:
														selectedItem?.id === item.id
															? "var(--primary-main)"
															: "inherit",
													fontWeight: "bold",
													overflow: "hidden",
													whiteSpace: "nowrap",
													textOverflow: "ellipsis",
												},
											}}
											title={item.machine_name}
										/>
									</ListItem>
								))
							) : (
								<div
									style={{
										textAlign: "center",
										padding: "20px",
										color: "gray",
										fontStyle: "italic",
										fontSize: "16px",
										height: "100%",
									}}>
									No Machines Found
								</div>
							)}
						</List>
					</Box>
				</Drawer>

				<Box display="flex" height="inherit">
					{!isMobile && (
						<Box
							width={isMobile ? "100%" : "20%"}
							pr={2}
							style={{
								padding: "8px",
								height: "inherit",
								overflowY: "auto",
								maxHeight: "inherit",
							}}>
							<Box display="flex" justifyContent="space-between" alignItems="center">
								<ContextFilterAndSort
									value={listSearchTerm}
									onSearchChange={handleListSearchChange}
									placeholder="Search list"
									options={sortOptions}
									selectedOption={sortOption}
									onSortChange={handleSortChange}
									showSort
									showSearch
								/>
							</Box>
							<List
								style={{
									overflowY: "auto",
									height: "calc(100% - 48px)",
									maxHeight: "500px",
								}}>
								{filteredItems.length > 0 ? (
									filteredItems.map((item) => (
										<ListItem
											key={item.id}
											button
											onClick={() => handleItemClick(item)}
											style={{
												cursor: "pointer",
												backgroundColor:
													selectedItem?.id === item.id ? "#e8e8e8" : "transparent",
												height: "45px",
											}}
											sx={{
												"&:hover": {
													color: "var(--primary-main)",
													transition: "0.2s",
												},
											}}>
											<ListItemText
												primary={item.machine_name}
												primaryTypographyProps={{
													style: {
														color:
															selectedItem?.id === item.id
																? "var(--primary-main)"
																: "inherit",
														fontWeight: "bold",
														overflow: "hidden",
														whiteSpace: "nowrap",
														textOverflow: "ellipsis",
													},
												}}
												title={item.machine_name}
											/>
										</ListItem>
									))
								) : (
									<div
										style={{
											textAlign: "center",
											padding: "20px",
											color: "gray",
											fontStyle: "italic",
											fontSize: "16px",
											height: "100%",
										}}>
										No Machines Found
									</div>
								)}
							</List>
						</Box>
					)}

					{!isMobile && <Divider flexItem orientation="vertical" sx={{ ml: 3, my: 0.5 }} />}

					<Box
						width={isMobile ? "100%" : "80%"}
						height="100%"
						px={2}
						py={2}
						borderRadius={1}
						justifyContent="flex-start"
						style={{ borderColor: "#ddd", height: "100%" }}
						display="flex"
						flexDirection="column">
						<Box
							display="flex"
							justifyContent="space-between"
							mb={2}
							alignItems={isMobile ? "flex-start" : "center"}
							flexDirection={isMobile ? "column" : "row"}
							width={isMobile ? "100%" : "auto"}>
							<Tabs value={tabValue} onChange={handleTabChange} aria-label="icon label tabs example">
								<Tab label="All" value="All" key="All" />
								{RSPL_LIST.map((list) => {
									if (Object.keys(spareParts).length !== 0 && spareParts[list.value].length > 0) {
										return <Tab label={list.value} value={list.value} key={list.value} />;
									}
								})}
							</Tabs>
							<Box
								display="flex"
								flexDirection="row"
								justifyContent={isMobile ? "space-between" : ""}
								gap="10px"
								width={isMobile ? "100%" : "auto"}
								sx={{ marginTop: isMobile ? 2 : 0 }}>

									<Button
										onClick={() => setDialogOpen(true)}
										variant="contained"
										startIcon={<FormatListBulletedIcon />}
										disabled={selectedProductRows.length < 1}>
										Add to My List
									</Button>

								<Button
									onClick={handleAddToCart}
									variant="contained"
									startIcon={<ShoppingCart />}
									disabled={selectedProductRows.length < 1}>
									Add To Cart
								</Button>
							</Box>
						</Box>

						<Dialog
							open={dialogOpen}
							onClose={() => setDialogOpen(false)}
							sx={{
								"& .MuiDialog-paper": {
									width: "500px",
									height: "400px",
								},
							}}>
							<DialogTitle>Select or Create a List</DialogTitle>
							<DialogContent>
								{!isCreatingNewList ? (
									<>
										<FormControl fullWidth margin="dense">
											<InputLabel id="select-list-label">Select List</InputLabel>
											<Select
												labelId="select-list-label"
												value={selectedList.id}
												size="small"
												onChange={(e) => {
													if (e.target.value === "newList") {
														setIsCreatingNewList(true);
													} else {
														setSelectedList(
															listItems.filter((i) => i.id === e.target.value)[0]
														);
													}
												}}
												label="Select List">
												{listItems.map((item) => (
													<MenuItem key={item.id} value={item.id}>
														{item.name}
													</MenuItem>
												))}
												<MenuItem key={"newList"} value={"newList"}>
													--- Create New List ---
												</MenuItem>
											</Select>
										</FormControl>
										<Divider sx={{ margin: "10px" }}>OR</Divider>
										<Button onClick={() => setIsCreatingNewList(true)} variant="outlined" fullWidth>
											Create New List
										</Button>
									</>
								) : (
									<Box>
										<TextField
											fullWidth
											label="List Name"
											value={newListName}
											onChange={(e) => setNewListName(e.target.value)}
											sx={{ marginBottom: 2, marginTop: 2 }}
										/>
										<TextField
											fullWidth
											label="List Description"
											value={newListDescription}
											onChange={(e) => setNewListDescription(e.target.value)}
											sx={{ marginBottom: 2 }}
										/>
									</Box>
								)}
							</DialogContent>
							<DialogActions>
								<Button
									onClick={() => {
										setDialogOpen(false);
										setIsCreatingNewList(false);
										setNewListName("");
										setNewListDescription("");
									}}>
									Cancel
								</Button>
								<Button
									onClick={handleSaveList}
									variant="contained"
									disabled={isCreatingNewList ? !newListName || !newListDescription : !selectedList}>
									Save
								</Button>
							</DialogActions>
						</Dialog>

						{selectedItem ? (
							<Box
								display="flex"
								flexWrap="wrap"
								justifyContent={isMobile ? "center" : "flex-start"}
								paddingX="15px"
								gap="10px"
								sx={{ overflowY: "auto", height: "100%" }}>
								{tabValue === -1 ? (
									<Box
										display="flex"
										justifyContent="center"
										alignContent="center"
										width="100%"
										alignItems="center"
										height="400px">
										<Alert severity="info">No products for selected machine</Alert>
									</Box>
								) : (
									<Box
										display="flex"
										justifyContent="center"
										alignContent="flex-start"
										width="100%"
										alignItems="center"
										columnGap={2}
										flexDirection={"row"}>
										<Box
											sx={{
												width: rsplSelected.length > 0 ? "70%" : "100%",
												transition: "width 0.3s ease",
												height: "100%",
											}}>
											<Datagrid
												key="product_id"
												data={partsData}
												rowClick={false}
												checkboxSelection={true}
												columns={columns}
												onSelect={handleRowSelect}
												pageSize={100}
												rowIdField="product_id"
												sortBy={[{ field: "product_name", sort: "asc" }]}
												sx={{ height: "400px" }}
											/>
										</Box>
										{rsplSelected.length > 0 && (
											<Box
												sx={{
													minWidth: "30%",
													width: "30%",
													minHeight: "650px",
													border: "1px solid #ddd",
													borderRadius: 1,
													padding: 2,
													maxHeight: "650px",
													overflowY: "auto",
													position: "sticky",
													top: "70px",
													alignSelf: "flex-start",
													backgroundColor: "#fff",
												}}>
												<Typography variant="h6" fontWeight="bold">
													Selected Parts
												</Typography>
												{/* Your scrollable content here */}
											</Box>
										)}
									</Box>
								)}
							</Box>
						) : (
							<Typography variant="body1" color="textSecondary">
								Select an item from the list
							</Typography>
						)}
					</Box>
				</Box>
			</Box>
			<Snackbar
				open={openAlert}
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				autoHideDuration={3000}
				onClose={() => setOpenAlert(false)}
				className="SnackBar">
				<Alert severity={alertisSuccess ? "success" : "error"} sx={{ width: "100%" }}>
					{alertMessage}
				</Alert>
			</Snackbar>
		</>
	);
}

export default Rspl;
